/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserResourceProgressProgress } from './userResourceProgressProgress';
import type { UserResourceProgressCompletedTimestamp } from './userResourceProgressCompletedTimestamp';

/**
 * return state and - if completed - when it was completed
 */
export interface UserResourceProgress {
  id: string;
  userId: string;
  resourceId: string;
  progress?: UserResourceProgressProgress;
  completed: boolean;
  completedTimestamp?: UserResourceProgressCompletedTimestamp;
}
